module.exports = __webpack_public_path__ + "img/logo--black.d96a30e2.svg";